<template>
  <div :class="wrapClasses">
    <input type="text" :placeholder="placeholder" @input="handleInput" />
  </div>
</template>

<script>
import { oneOf } from "@/utils/assist";

const prefixCls = "gy-input";
export default {
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    type: {
      validator(value) {
        return oneOf(value, [
          "text",
          "textarea",
          "password",
          "url",
          "email",
          "date",
          "number",
          "tel",
        ]);
      },
      default: "text",
    },
    placeholder: {
      type: String,
      default: "",
    },
    showPassword: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    wrapClasses() {
      return [`${prefixCls}-wrapper`];
    },
    currentType() {
      let type = this.type;
      if (type === "password" && this.showPassword) {
        type = "text";
      }
      return type;
    },
  },
  data() {
    return {
      currentValue: this.value,
    };
  },
  methods: {
    handleInput(event) {
      let value = event.target.value;
      if (this.number && value !== "")
        value = Number.isNaN(Number(value)) ? value : Number(value);
      this.$emit("input", value);
      this.setCurrentValue(value);
      this.$emit("on-change", event);
    },
    setCurrentValue(value) {
      if (value === this.currentValue) return;
      this.currentValue = value;
    },
  },
};
</script>
